import React from 'react';
import SiteRenderer from './SiteRenderer';
import RestaurantExempleView from './restaurant-exemple/RestaurantExempleView';
import { getRestaurantPageComponent } from '../utils/restaurantExempleDefaults';
import { shouldRenderMonolithRestaurant } from '../utils/designKit';
import { getCommerceCapabilities } from '../utils/commerce';
import { migrateSite } from '../utils/defaults';

/**
 * Rendu unique pour aperçu éditeur et page publiée (/lp/:slug).
 * Applique les mêmes migrations et le même moteur SiteRenderer.
 */
export default function WebCreatorSitePageView({
  site,
  viewport,
  interactive = true,
  checkoutSlug,
  onCommerceNavigate,
  onOrderComplete,
  showBrandingFooter = false,
  className = '',
}) {
  if (!site) return null;

  const migrated = migrateSite(site);
  const slug = checkoutSlug || migrated.slug;
  const commerceCapabilities = getCommerceCapabilities(migrated);
  const monolith = shouldRenderMonolithRestaurant(migrated);
  const restaurantPageComp = monolith ? getRestaurantPageComponent(migrated) : null;

  if (restaurantPageComp) {
    return (
      <div className={className}>
        <RestaurantExempleView
          props={restaurantPageComp.props}
          site={migrated}
          slug={slug}
          interactive={interactive && Boolean(slug)}
          commandeUrl={slug ? `/lp/${encodeURIComponent(slug)}/commande` : undefined}
        />
      </div>
    );
  }

  const vp = viewport || 'desktop';

  return (
    <div
      className={`web-creator-public-root w-full ${className}`.trim()}
      data-wc-viewport={vp}
    >
      <SiteRenderer
        sections={migrated.sections || []}
        pageMenu={migrated.pageMenu}
        pageBackground={migrated.pageBackground}
        typography={migrated.typography}
        viewport={viewport}
        interactive={interactive}
        site={migrated}
        checkoutSlug={slug}
        commerceCapabilities={commerceCapabilities}
        onCommerceNavigate={onCommerceNavigate}
        onOrderComplete={onOrderComplete}
        showBrandingFooter={showBrandingFooter}
        playAnimations
      />
    </div>
  );
}
